/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useParams } from 'react-router'
import { useHistory } from 'react-router-dom'
import { Growl } from 'primereact/growl'

import { messageConstants } from '../_constants'
import { getLoader, titleCase } from '../_common/utils'
import AddCompanyComponent from '../components/AddCompanyComponent'
import { companyActions, lookupActions } from '../_actions'
function AddCompanyContainer({ lookup, lookupData, addCompany, logoUpload,
  getCompanyById, singleEntry, logo, addCompanyMessage, clearAllMessages, companyList, lookupIndustry, updateSubBrand, subBrandData, bulkUpdate, bulkUpdatesubBrand, deleteCompany, isLoading, bulkUpdateSuccessMessage }) {

  const { industryId, sectorId } = useParams()
  const history = useHistory()
  const growl = useRef()
  const { id } = useParams()
  useEffect(() => {
    if (addCompanyMessage === 'success') {
      growl.current.show({ severity: 'success', summary: '', detail: 'Company Added Successfully' })
      clearAllMessages()
      setTimeout(function () {
        if (sectorId && industryId && !id) {
          history.push('/dashboard/industry-list')
        } else {
          history.push('/dashboard/company-list')
        }
      }, 3000)

    } else if (addCompanyMessage === 'companyname-exist') {
      growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: 'Company name already exists under the selected sector and sub industry' })
      clearAllMessages()
    }
    else if (addCompanyMessage === 'companynameexist') {
      growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: 'Company name already exists' })
      clearAllMessages()
    }
  }, [addCompanyMessage])
  useEffect(() => {
    lookupData('force')
  }, [companyList])
  useEffect(() => {
    if (bulkUpdateSuccessMessage && bulkUpdateSuccessMessage === 'success') {
      growl.current.show({ severity: messageConstants.sevirity.success, summary: '', detail: titleCase('Updated ') + ' ' + messageConstants.activeCompany.success })
      setTimeout(function () { clearAllMessages(); history.push('/dashboard/company-list') }, 1000)
    }
  }, [bulkUpdateSuccessMessage])
  return (
    <div className="p-grid pageWrapper">
      {isLoading ? getLoader() : ''}
      <Growl ref={growl} />
      <AddCompanyComponent
        masterList={lookup}
        addCompany={addCompany}
        logoUpload={logoUpload}
        getCompanyById={getCompanyById}
        singleEntry={singleEntry}
        logo={logo}
        lookupData={lookupData}
        lookupIndustry={lookupIndustry}
        addCompanyMessage={addCompanyMessage}
        updateSubBrand={updateSubBrand}
        subBrandData={subBrandData}
        bulkUpdate={bulkUpdate}
        bulkUpdatesubBrand={bulkUpdatesubBrand}
        deleteCompany={deleteCompany}
      />
    </div>
  )
}

AddCompanyContainer.propTypes = {
  lookup: PropTypes.object,
  lookupData: PropTypes.func,
  addCompany: PropTypes.func,
  logoUpload: PropTypes.func,
  getCompanyById: PropTypes.func,
  singleEntry: PropTypes.object,
  logo: PropTypes.object,
  addCompanyMessage: PropTypes.string,
  clearAllMessages: PropTypes.func,
  companyList: PropTypes.array,
  lookupIndustry: PropTypes.func,
  updateSubBrand: PropTypes.func,
  subBrandData: PropTypes.object,
  bulkUpdate: PropTypes.func,
  bulkUpdatesubBrand: PropTypes.func,
  bulkUpdateSuccessMessage: PropTypes.string,
}
const mapStateToProps = state => {
  console.log(state.company)
  return {
    lookup: state.lookup,
    companyList: state.company.companyList ? state.company.companyList : [],
    singleEntry: state.company.singleEntry ? state.company.singleEntry : null,
    logo: state.company.logoUpload ? state.company.logoUpload : null,
    addCompanyMessage: state.company.addCompanyMessage,
    subBrandData: state.company.subBrandData,
    isLoading: state.company.isLoading,
    bulkUpdateSuccessMessage: state.company.bulkUpdateSuccessMessage
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    lookupData: (force) => dispatch(lookupActions.lookupData(force)),
    lookupIndustry: () => dispatch(lookupActions.lookupIndustry()),
    addCompany: (company) => dispatch(companyActions.addCompany(company)),
    logoUpload: (file) => dispatch(companyActions.logoUpload(file)),
    getCompanyById: (id) => dispatch(companyActions.getCompanyById(id)),
    clearAllMessages: () => dispatch(companyActions.clearAllMessages()),
    updateSubBrand: (data) => dispatch(companyActions.updateSubBrand(data)),
    bulkUpdate: (companyList) => dispatch(companyActions.bulkUpdate(companyList)),
    bulkUpdatesubBrand: (companyList) => dispatch(companyActions.bulkUpdatesubBrand(companyList)),
    deleteCompany: (id, userId) => dispatch(companyActions.deleteCompany(id, userId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCompanyContainer)
